import React, { useEffect, useContext, useState, useRef } from 'react';
import ComponentProvider, { ComponentContext } from '../ComponentProvider';
import { QuantityInput } from './'


export const VariantOptionsForm = ({ object, selectedVariant, options, variants, handleChange }) => {
  const { bundleState } = useContext(ComponentContext);
  const [bundle, setBundle] = bundleState
  const [isAdded, setIsAdded] = useState(false);

  useEffect(() => {
    bundle.find(i => i.id == selectedVariant?.id) ? setIsAdded(true) : setIsAdded(false)
  }, [bundle, selectedVariant])

  const handleSubmit = (e, variant) => {
    e.preventDefault()
    const formData = new FormData(e.target)

    if (!bundle.find(i => i.id == selectedVariant.id)) {
      const toAdd = {
        id: variant.id,
        quantity: parseInt(formData.get('quantity')),
        product: object,
        image: variant.featured_image ? variant.featured_image : object.featured_image,
        variant: variant
      }
      setBundle([
        ...bundle,
        toAdd
      ])
    }
  }

  return (
    <form className='options' onSubmit={e => handleSubmit(e, selectedVariant)} >
      {
        object.variants.length > 1 &&
        options.map((o, idx) =>
          <div key={`${object.handle}-${o}`} className="variant-options">
            <label>{o}</label>
            <select name={o} onChange={handleChange} defaultValue={selectedVariant?.options[object.options.indexOf(o)]} >
              {[...new Set(variants.map(v => v[`option${idx + 1}`]))].map(i => <option key={`${object.handle}-${i}`} value={i}>{i}</option>)}
            </select>
          </div>
        )
      }
      <QuantityInput
        selectedVariant={selectedVariant}
        show={isAdded}
      />
      {!isAdded &&
        <button type="submit" className='Button Button--add' disabled={!selectedVariant || !selectedVariant.available}>
          <span>{selectedVariant?.available ? 'Add' : 'Unavailable'}</span>
        </button>
      }
    </form>
  )
}

